/* eslint-disable react/button-has-type */
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Navbarlogo from '../../Assets/elvotaimages/Evolta-Logo.svg';

export default function Navbar() {
  const [navbarBg] = useState(false);
  const [navbarcollapse, setNavbarcollapse] = useState(false);

  // Get the current route path
  const location = useLocation();
  const currentPath = location.pathname;
  const navigate = useNavigate(); // Initialize the useNavigate hook

  return (
    <nav
      className={`${
        navbarBg ? 'bg-green' : 'bg-white'
      } transition-colors duration-500 border-gray-200 fixed w-full z-20 top-0 start-0`}
    >
      <div className="w-11/12 2xl:w-[1210px] flex flex-wrap items-center justify-between mx-auto py-[13px]">
        <Link
          to="/"
          className="flex items-center space-x-3 rtl:space-x-reverse"
        >
          <img
            src={Navbarlogo}
            className="w-[192px] h-[32px]"
            alt="Evolta Logo"
          />
        </Link>
        <button
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100"
          onClick={() => setNavbarcollapse(!navbarcollapse)}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill={`${navbarBg ? '#A1FF75' : '#fff'}`}
            viewBox="0 0 17 14"
          >
            <path
              stroke="#114036"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={`${
            navbarcollapse ? 'block' : 'hidden'
          } w-full md:block md:w-auto`}
          id="navbar-default"
        >
          <ul className="md:items-center flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-[30px] rtl:space-x-reverse md:mt-0 md:border-0 md:bg-transparent">
            <li>
              <Link
                to="/solution"
                className={`${
                  currentPath === '/solution'
                    ? 'text-green font-bold'
                    : 'text-black'
                } ${
                  navbarBg ? 'hover:text-white' : 'hover:text-green'
                } block py-2 px-3 rounded md:bg-transparent f-f-sm text-lg md:p-0 transition-colors duration-500`}
                aria-current={currentPath === '/solution' ? 'page' : undefined}
              >
                Solutions
              </Link>
            </li>
            <li>
              <Link
                to="/about-us"
                className={`${
                  currentPath === '/about-us'
                    ? 'text-green font-bold'
                    : 'text-black'
                } ${
                  navbarBg ? 'hover:text-white' : 'hover:text-green'
                } block py-2 px-3 rounded md:bg-transparent f-f-sm text-lg md:p-0 transition-colors duration-500`}
                aria-current={currentPath === '/about-us' ? 'page' : undefined}
              >
                About Us
              </Link>
            </li>
            <li>
              <button
                className="w-[116px] h-[41px] bg-green hover:bg-black-light hover:text-white transition-colors duration-500 rounded-[20px] f-f-sm text-sm text-black-light"
                onClick={() => navigate('/contact-us#evolta_contact_form')}
              >
                Contact Us
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
